const DEFAULT_TIMEOUT = 1500;

const runWhenIdle = (callback, { timeout = DEFAULT_TIMEOUT } = {}) => {
    if (typeof window === "undefined") {
        callback();
        return () => {};
    }

    if ("requestIdleCallback" in window) {
        const id = window.requestIdleCallback(callback, { timeout });
        return () => window.cancelIdleCallback(id);
    }

    const id = setTimeout(callback, Math.min(timeout, 300));
    return () => clearTimeout(id);
};

export default runWhenIdle;
